import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const DrugDemoPage = lazy(() =>
    import(/* webpackChunkName: "drug-demo" */ '../ui/DrugDemoPage').then(m => ({
        default: m.DrugDemoPage,
    })),
);

export const drugDemoLocations: Location[] = [
    {
        url: '/drug-demo',
        Component: DrugDemoPage,
    },
];
